import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetAvailableRefinLoans = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.loan.refin_available_loans, params],
    queryFn: () =>
      loanService.refinAvailableLoans(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
